import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * System Module Service Stores
 *
 * Declares the ServiceStores backing the "core" domain stores (global search,
 * client selector, settings⇄DB sync). These replace the removed `createRestApi`
 * raw REST client: the ViewStores read `rootStore.<name>Store.entities` and call
 * `.find/.get/.create/.patch/.remove` on the registered ServiceStore instead.
 */
export const systemStores: ServiceStoreConfig[] = [
  // Omnibar global search. find() returns a `{ total, results, byType }` summary
  // envelope (no `data[]` array), so AppLayoutStore reads the find() response
  // directly rather than the entity cache. enableStorage off — results are
  // query-scoped and must never be cached/restored. enableOffline OFF is
  // REQUIRED: the offline-capable store cannot represent this bare envelope —
  // it would null the result and crash in cacheResults, blanking the omnibar.
  {
    name: "global-search",
    options: { idField: "id", enableStorage: false, enableOffline: false },
  },
  // Read-only system health rollup; find() returns a bare snapshot object (no
  // `{ data, total }` envelope), consumed directly by SystemHealth.Body. Same
  // reason as above — enableOffline OFF so the plain ServiceStore returns the
  // snapshot verbatim instead of nulling it in the offline wrapper.
  {
    name: "system-health",
    options: { idField: "id", enableStorage: false, enableOffline: false },
  },
  // Read-only capability-readiness report. find-only, and find() returns a BARE
  // report object (no `{ data, total }` envelope). enableStorage off — it is a
  // live assessment, never persisted. enableOffline OFF is REQUIRED, the same
  // opt-out `dashboard-summary` and `instance-actions` already carry: the
  // offline wrapper's blanket sync-on-reconnect issues a bare `find()` whose
  // bare-object response it cannot cache (cacheResults would be handed a null),
  // so the reconnect resync would fail and the report would blank. The plain
  // ServiceStore returns the report verbatim.
  {
    name: "capability-readiness",
    options: { idField: "id", enableStorage: false, enableOffline: false },
  },
  // The tenant `clients` collection backing the global client selector and the
  // right-nav client menu. Standard CRUD keyed by `id`.
  { name: "clients", options: { idField: "id", enableStorage: false } },
  // The authenticated user's preferences singleton, addressed as `.../me`.
  // settingsSync hydrates via get("me") and write-backs via patch("me", body).
  { name: "user-preferences", options: { idField: "id", enableStorage: false } },
];
